import App from '../app';
import join from './join';

const Modules = {
    join
}

App.init(Modules);
